import { useState } from "react";
import { X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const ROWS = [
  { size: "S", chest: "20", length: "27", sleeve: "8.5" },
  { size: "M", chest: "21.5", length: "28", sleeve: "9" },
  { size: "L", chest: "23", length: "29", sleeve: "9.5" },
  { size: "XL", chest: "24.5", length: "30", sleeve: "10" },
  { size: "2XL", chest: "26", length: "31", sleeve: "10.5" },
];

export default function SizeGuide() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        data-testid="size-guide-button"
        onClick={() => setOpen(true)}
        className="font-mono text-[10px] tracking-[0.2em] text-neutral-400 underline underline-offset-4 transition-colors hover:text-white"
      >
        SIZE GUIDE
      </button>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              data-testid="size-guide-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setOpen(false)}
              className="fixed inset-0 z-[90] bg-black/75 backdrop-blur-sm"
            />
            <motion.div
              data-testid="size-guide-modal"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 24 }}
              transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="fixed left-1/2 top-1/2 z-[100] w-[calc(100%-2.5rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 border border-wire bg-charcoal"
              role="dialog"
              aria-modal="true"
              aria-label="Size guide"
            >
              <div className="flex items-center justify-between border-b border-wire px-6 py-5">
                <p className="font-mono text-[11px] tracking-[0.35em] text-neutral-300">SIZE GUIDE — CLASSIC TEE</p>
                <button data-testid="size-guide-close" onClick={() => setOpen(false)} className="p-1 text-neutral-400 hover:text-white" aria-label="Close size guide">
                  <X size={16} />
                </button>
              </div>

              <div className="px-6 py-6">
                <table className="w-full" data-testid="size-guide-table">
                  <thead>
                    <tr className="border-b border-wire">
                      {["SIZE", "CHEST (IN)", "LENGTH (IN)", "SLEEVE (IN)"].map((h) => (
                        <th key={h} className="pb-3 text-left font-mono text-[9px] tracking-[0.25em] text-neutral-500 last:text-right">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {ROWS.map((r) => (
                      <tr key={r.size} className="border-b border-wire/60" data-testid={`size-guide-row-${r.size.toLowerCase()}`}>
                        <td className="py-3 font-mono text-xs tracking-[0.2em] text-white">{r.size}</td>
                        <td className="py-3 font-mono text-xs text-neutral-300">{r.chest}</td>
                        <td className="py-3 font-mono text-xs text-neutral-300">{r.length}</td>
                        <td className="py-3 text-right font-mono text-xs text-neutral-300">{r.sleeve}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="mt-6 space-y-3 font-mono text-[10px] leading-relaxed tracking-[0.15em] text-neutral-400">
                  <p>/ RELAXED STREETWEAR FIT — TRUE TO SIZE</p>
                  <p>/ SIZE DOWN FOR A CLOSER FIT, UP FOR OVERSIZED</p>
                  <p>/ GARMENT MEASURED FLAT — CHEST IS PIT TO PIT</p>
                  <p>/ VINTAGE WASH — EXPECT UP TO 3% SHRINKAGE ON FIRST WASH. COLD WASH, HANG DRY</p>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
